import Cookies from 'js-cookie';
import { sortArrayOfDates } from '../functions';

const initialLeadsState = {
  isFetching: true,
  transcriptEnabled: false,
  currentPage: 0,
  perPage: 10,
  answeredCalls: [],
  leads: [],
  calls: [],
  callsToExport: [],
  formLeadsToExport: [],
  markedLeadsToExport: [],
  callsByStatusChartLabels: [],
  callsByStatusChartSeries: [],
  callsByStatusCurrentPeriod: {},
  currentLead: {},
  totalCalls: 0,
  totalAnsweredCalls: 0,
  total: 0,
  isFullView: false,
  currentStatus: 'new',
  allLeadsCount: 0,
  currentPeriodLeadsCount: 0,
  prevPeriodLeadsCount: 0,
  allPhoneCallsCount: 0,
  currentPeriodCallsCount: 0,
  prevPeriodCallsCount: 0,
  isSearching: false,
  searchKeyword: '',
  leadsByMonth: {},
  callsByMonth: {},
  leadsByMonthChartLabels: [],
  leadsByMonthChartSeries: [{ data: [] }],
  callsByMonthChartLabels: [],
  callsByMonthChartSeries: [{ data: [] }],
  overallLeadsByMonth: {},
  overallLeadsByMonthChartLabels: [],
  overallLeadsByMonthChartSeries: [{ data: [] }],
  roiChartLabels: [],
  roiChartSeries: [{ data: [] }],
  clientBudget: 0,
};

const leadsActions = {
  LEADS_SET_ALL: 'LEADS_SET_ALL',
  LEADS_SET_EXPORT: 'LEADS_SET_EXPORT',
  MARKED_LEADS_SET_EXPORT: 'MARKED_LEADS_SET_EXPORT',
  LEADS_SET_IS_FETCHING: 'LEADS_SET_IS_FETCHING',
  LEADS_CLEAN: 'LEADS_CLEAN',
  LEADS_UPDATE_LEAD: 'LEADS_UPDATE_LEAD',
};

function leadsReducer(state, action) {
  const newState = { ...state };
  switch (action.type) {
    case leadsActions.LEADS_SET_ALL:
      if (action.payload.leadsByMonth) {
        newState.overallLeadsByMonthChartLabels = [];
        newState.leadsByMonthChartLabels = [];
        newState.leadsByMonthChartSeries = [{ data: [] }];
        newState.leadsByMonthChartLabels = Object.keys(action.payload.leadsByMonth);
        newState.overallLeadsByMonth = newState.callsByMonth;
        newState.leadsByMonthChartLabels.forEach((key) => {
          newState.leadsByMonthChartSeries[0].data.push(
            action.payload.leadsByMonth[key].toString()
          );
          if (newState.overallLeadsByMonth[key]) {
            newState.overallLeadsByMonth[key] += action.payload.leadsByMonth[key];
          } else {
            newState.overallLeadsByMonth[key] = action.payload.leadsByMonth[key];
          }
        });
        newState.overallLeadsByMonthChartSeries = [{ data: [] }];
        let overallLeadsByMonthChartFullLabels = sortArrayOfDates(
          Object.keys(newState.overallLeadsByMonth)
        );
        overallLeadsByMonthChartFullLabels = overallLeadsByMonthChartFullLabels.slice(-6);
        newState.roiChartSeries = [{ data: [] }];
        overallLeadsByMonthChartFullLabels.forEach((key) => {
          newState.overallLeadsByMonthChartLabels.push(
            new Date(`01 ${key}`).toLocaleString('en-US', { month: 'short' })
          );
          if (Cookies.get('budget') !== 'null') {
            newState.roiChartSeries[0].data.push(
              (Cookies.get('budget') / newState.overallLeadsByMonth[key]).toFixed(0).toString()
            );
          } else {
            newState.roiChartSeries[0].data.push(
              (0 / newState.overallLeadsByMonth[key]).toFixed(0).toString()
            );
          }

          newState.overallLeadsByMonthChartSeries[0].data.push(
            newState.overallLeadsByMonth[key].toString()
          );
        });
        newState.roiChartLabels = newState.overallLeadsByMonthChartLabels;
      }
      if (action.payload.callsByStatusCurrentPeriod) {
        newState.callsByStatusChartLabels = Object.keys(action.payload.callsByStatusCurrentPeriod);
        newState.callsByStatusChartSeries = [];
        newState.callsByStatusChartLabels.forEach((key) => {
          newState.callsByStatusChartSeries.push(action.payload.callsByStatusCurrentPeriod[key]);
        });
      }
      if (action.payload.callsByMonth) {
        newState.overallLeadsByMonthChartLabels = [];
        newState.callsByMonthChartLabels = [];
        newState.callsByMonthChartSeries = [{ data: [] }];
        newState.callsByMonthChartLabels = Object.keys(action.payload.callsByMonth);
        newState.overallLeadsByMonth = newState.leadsByMonth;
        newState.callsByMonthChartLabels.forEach((key) => {
          newState.callsByMonthChartSeries[0].data.push(
            action.payload.callsByMonth[key].toString()
          );
          if (newState.overallLeadsByMonth[key]) {
            newState.overallLeadsByMonth[key] += action.payload.callsByMonth[key];
          } else {
            newState.overallLeadsByMonth[key] = action.payload.callsByMonth[key];
          }
        });
        newState.overallLeadsByMonthChartSeries = [{ data: [] }];
        let overallLeadsByMonthChartFullLabels = sortArrayOfDates(
          Object.keys(newState.overallLeadsByMonth)
        );
        overallLeadsByMonthChartFullLabels = overallLeadsByMonthChartFullLabels.slice(-6);
        newState.roiChartSeries = [{ data: [] }];
        overallLeadsByMonthChartFullLabels.forEach((key) => {
          newState.overallLeadsByMonthChartLabels.push(
            new Date(`01 ${key}`).toLocaleString('en-US', { month: 'short' })
          );
          if (Cookies.get('budget') !== 'null') {
            newState.roiChartSeries[0].data.push(
              (Cookies.get('budget') / newState.overallLeadsByMonth[key]).toFixed(0).toString()
            );
          } else {
            newState.roiChartSeries[0].data.push(
              (0 / newState.overallLeadsByMonth[key]).toFixed(0).toString()
            );
          }

          newState.overallLeadsByMonthChartSeries[0].data.push(
            newState.overallLeadsByMonth[key].toString()
          );
        });
        newState.roiChartLabels = newState.overallLeadsByMonthChartLabels;
      }
      return { ...newState, ...action.payload };
    case leadsActions.LEADS_SET_IS_FETCHING:
      return { ...state, isFetching: action.payload.isFetching };
    case leadsActions.LEADS_SET_EXPORT:
      return { ...state, formLeadsToExport: action.payload.formLeadsToExport };
    case leadsActions.MARKED_LEADS_SET_EXPORT:
      return { ...state, markedLeadsToExport: action.payload.markedLeadsToExport };
    case leadsActions.LEADS_CLEAN:
      return structuredClone(initialLeadsState);
    case leadsActions.LEADS_UPDATE_LEAD:
      for (let i = 0; i < newState.leads.length; i += 1) {
        const el = newState.leads[i];
        if (el.uuid === action.payload.uuid) {
          newState.leads.splice(i, 1);
        }
      }
      newState.total -= 1;
      return newState;
    default:
      return state;
  }
}

export { initialLeadsState, leadsActions, leadsReducer };
